




















import { BSpinner } from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { VueSelect } from "vue-select";

@Component({
  components: {
    VueSelect,
    BSpinner
  },
  name: "searchable-vue-select",
})
export default class SearchableVueSelect extends Vue {
  @Prop({ required: true }) hasNextPage!: boolean
  @Prop({ required: false, default: false }) loadOnCreate!: boolean 
  @Prop({ required: false, default: true }) load!: boolean 
  observer: any = null
  
  search= ""
  pageSize = 10
  pageNumber = 1

  timeout: any
  isLoading = true

  ul?: any
  scrolledPixels = 0

  created() {
    if(this.loadOnCreate) {
      this.$emit('load-next-page', {
        pageNumber: this.pageNumber, 
        pageSize: this.pageSize, 
        search: this.search,
        reset: true
      })
    }
    if (this.load) setTimeout(() => this.isLoading = false, 5000)
    else this.isLoading = false
  }
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
  }

  searchChanged(query: string) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.pageNumber = 1
      this.search = query
      
      this.$emit('load-next-page', {
        pageNumber: this.pageNumber, 
        pageSize: this.pageSize, 
        search: this.search,
        reset: true
      })
    }, 1300)
  }


  async onOpen() {
    if (this.hasNextPage) {
      await this.$nextTick();
      this.observer.observe(this.$refs.load);
    }
  }
  
  onClose() {
    this.observer.disconnect();
  }

  @Watch('$attrs.options')
  async watchOptions() {
    await this.$nextTick()
    if (this.ul)
      this.ul.scrollTop = this.scrolledPixels
  }

  async infiniteScroll([{ isIntersecting, target }] : any[]) {
    if (isIntersecting) {
      this.ul = target.offsetParent;
      this.scrolledPixels = target.offsetParent.scrollTop;
      this.pageNumber += 1;
      
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$emit('load-next-page', {
          pageNumber: this.pageNumber, 
          pageSize: this.pageSize, 
          search: this.search,
          reset: false
        })
      })
    }
  }
}

